import styled from "styled-components";

// FormWrapper compartilhado para reutilização
export const FormWrapper = styled.div`
  .MuiFormControl-root {
    .MuiInputLabel-root {
      color: #b0b0b0 !important;
      
      &.Mui-focused {
        color: #00d4ff !important;
      }
    }
    
    .MuiOutlinedInput-root {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      color: #ffffff !important;
      transition: all 0.3s ease;
      height: 48px !important;
      min-height: 48px !important;
      
      @media (min-width: 768px) {
        border-radius: 9px;
        height: 52px !important;
        min-height: 52px !important;
      }
      
      @media (min-width: 992px) {
        border-radius: 10px;
        height: 56px !important;
        min-height: 56px !important;
      }
      
      fieldset {
        border-color: rgba(255, 255, 255, 0.1);
        border-width: 2px;
      }
      
      &:hover fieldset {
        border-color: rgba(0, 212, 255, 0.3);
      }
      
      &.Mui-focused {
        background: rgba(255, 255, 255, 0.08);
        
        fieldset {
          border-color: #00d4ff;
          border-width: 2px;
        }
      }
      
      .MuiInputBase-input {
        color: #ffffff !important;
        height: 48px !important;
        padding: 12px 14px !important;
        font-family: 'Nunito', Helvetica, Sans-Serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        
        @media (min-width: 768px) {
          height: 52px !important;
          padding: 14px 14px !important;
          font-size: 15px !important;
        }
        
        @media (min-width: 992px) {
          height: 56px !important;
          padding: 16.5px 14px !important;
          font-size: 16px !important;
        }
        
        &::placeholder {
          color: #888;
          opacity: 1;
          font-family: 'Nunito', Helvetica, Sans-Serif !important;
        }
        
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
          -webkit-text-fill-color: #ffffff !important;
          -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
          box-shadow: 0 0 0px 1000px transparent inset !important;
          background-color: transparent !important;
          transition: background-color 5000s ease-in-out 0s;
        }
      }
      
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-text-fill-color: #ffffff !important;
        -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
        box-shadow: 0 0 0px 1000px transparent inset !important;
        background-color: transparent !important;
        transition: background-color 5000s ease-in-out 0s;
      }
      
      .MuiInputAdornment-root {
        .MuiInputAdornment-positionStart {
          color: #ffffff !important;
        }
        
        .MuiTypography-root {
          color: #ffffff !important;
        }
      }
    }
    
    .MuiFormHelperText-root {
      color: #b0b0b0;
    }
  }
  
  .MuiInputAdornment-root {
    color: #ffffff !important;
    
    .MuiTypography-root {
      color: #ffffff !important;
    }
  }
  
  .MuiSelect-root {
    color: #ffffff !important;
  }
  
  .MuiSelect-icon {
    color: #ffffff !important;
  }
  
  .MuiOutlinedInput-root {
    .MuiSelect-icon {
      color: #ffffff !important;
    }
  }
  
  .MuiMenuItem-root {
    background: #1a1a2e;
    color: #e0e0e0;
    
    &:hover {
      background: rgba(0, 212, 255, 0.1);
    }
    
    &.Mui-selected {
      background: rgba(0, 212, 255, 0.2);
      color: #00d4ff;
    }
  }
  
  .MuiButton-root {
    height: 56px !important;
    min-height: 56px !important;
    line-height: normal !important;
  }
  
  /* Estilizar ícones dos DatePickers para branco */
  .MuiOutlinedInput-root {
    .MuiInputAdornment-root {
      .MuiIconButton-root {
        color: #ffffff !important;
        
        svg {
          color: #ffffff !important;
        }
      }
    }
  }
  
  /* Estilizar ícones do DatePicker (MUI X Date Pickers) */
  .MuiInputAdornment-root {
    .MuiIconButton-root {
      color: #ffffff !important;
      
      svg {
        color: #ffffff !important;
      }
    }
  }
`;

// Card moderno compartilhado
export const ModernCard = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 212, 255, 0.1);
  overflow: hidden;
  border: 1px solid rgba(0, 212, 255, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 212, 255, 0.2);
  }
`;

// Botão primário com gradiente ciano
export const PrimaryButton = styled.button`
  background: linear-gradient(135deg, #00d4ff 0%, #0099cc 100%);
  border: none;
  color: #ffffff;
  padding: 14px 32px;
  border-radius: 10px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 212, 255, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Botão secundário
export const SecondaryButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: #e0e0e0;
  padding: 14px 28px;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

// Botão com gradiente laranja
export const OrangeButton = styled.button`
  background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
  border: none;
  color: #ffffff;
  padding: 14px 32px;
  border-radius: 10px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(242, 146, 5, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(242, 146, 5, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Card com destaque laranja (mantido para compatibilidade, mas pode usar CyanAccentCard)
export const OrangeAccentCard = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(242, 146, 5, 0.2);
  border: 1px solid rgba(242, 146, 5, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  
  @media (min-width: 576px) {
    border-radius: 18px;
    padding: 24px;
  }
  
  @media (min-width: 768px) {
    border-radius: 20px;
    padding: 28px;
  }
  
  @media (min-width: 992px) {
    padding: 32px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(242, 146, 5, 0.3);
  }
`;

// Card com destaque ciano (novo, para usar no Dashboard)
export const CyanAccentCard = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 212, 255, 0.2);
  border: 1px solid rgba(0, 212, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 212, 255, 0.3);
  }
`;

